import React from "react";
import { Paper, Typography, Stack, Chip, Box } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { getPresetPreviewChips } from "../../utils/queryBuilderPresets";
import { BRAND_COLORS, brandRgba } from "../../utils/brandAssets";

const QueryPresetCard = ({
  preset,
  selected = false,
  compact = false,
  onClick,
}) => {
  const chips = getPresetPreviewChips(preset);

  return (
    <Paper
      component="button"
      type="button"
      onClick={() => onClick(preset)}
      sx={{
        p: compact ? 1.75 : 2,
        width: "100%",
        height: "100%",
        textAlign: "left",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        font: "inherit",
        color: "inherit",
        border: "1px solid",
        borderColor: selected ? "primary.main" : "divider",
        bgcolor: selected ? "action.selected" : "background.paper",
        transition: "transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          borderColor: "primary.main",
          boxShadow: `0 8px 24px ${brandRgba(BRAND_COLORS.cyan, 0.12)}`,
        },
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={1}
        sx={{ flex: 1, height: "100%" }}
      >
        <Box sx={{ minWidth: 0, display: "flex", flexDirection: "column", flex: 1 }}>
          <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5 }}>
            {preset.title}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            sx={{ mb: chips.length ? 1.25 : 0, flex: 1 }}
          >
            {preset.subtitle}
          </Typography>
          {chips.length > 0 && (
            <Stack direction="row" flexWrap="wrap" gap={0.75} sx={{ mt: "auto" }}>
              {chips.map((chip) => (
                <Chip key={chip} label={chip} size="small" variant="outlined" />
              ))}
            </Stack>
          )}
        </Box>
        <PlayArrowIcon
          fontSize="small"
          sx={{ color: "primary.main", opacity: 0.85, flexShrink: 0, mt: 0.25 }}
        />
      </Stack>
    </Paper>
  );
};

export default QueryPresetCard;
